/**
 * roles — the ONE elevated-platform-role predicate (R14: byte-identical
 * checks scattered across files is drift-in-waiting). Every gate that needs
 * "super_admin | platform_owner" calls `isElevatedRole`; the role tuple is
 * spelled out in exactly one place. Consumers: PlatformGate, the navigation
 * `elevated` gate, AdminPage, and adsToolsAccess.canAccessAdmin.
 */

/**
 * True for the two elevated platform roles. Pass the raw `platform_role`
 * string off a user profile (NOT the profile object).
 *
 * `expert` is intentionally excluded — it is a content-internals role
 * (canAccessInternalAdsTools), never an admin/platform role.
 */
export function isElevatedRole(
  platformRole: string | null | undefined,
): boolean {
  return platformRole === 'super_admin' || platformRole === 'platform_owner';
}
